import KoboConverter from "Components/KoboConverter";
import { useGetCustomerOrderHistoryQuery } from "hooks/CustomerManagement/useGetCustomerOrderHistoryQuery";
import { Link, useParams } from "react-router-dom";

const OrderHistory = () => {
  const { id } = useParams();
  const { data } = useGetCustomerOrderHistoryQuery(`${id}`);
  return (
    <div>
      <div className="flex justify-between items-center mb-[30px] mt-[30px]">
        <h2 className="text-[#562B00] text-[20px] font-semibold">
          Order History (
          {data?.data?.meta?.totalDocs &&
            `${data?.data?.meta?.totalDocs + " " + "Orders"}`}
          )
        </h2>
        <Link
          to={`/customer-management/${id}/orders`}
          className="text-orange underline"
        >
          More
        </Link>
      </div>

      <div className="border-[1px] border-[#eeeeee] rounded-[10px]">
        <div className="flex gap-3 text-[#828282] px-[10px] py-[20px] border-b-[1px] border-[#eeeeee] ">
          <div className="w-5/12">Product</div>
          <div className="w-4/12">Price</div>
          <div className="w-3/12">Status</div>
        </div>
        {data?.data?.docs &&
          data?.data?.docs
            ?.slice(0, 4)
            .map(
              ({
                id,
                orderProducts,
                totalProductsAmount,
                orderStatus,
              }: any) => (
                <div
                  className="flex gap-3 px-[10px] py-[20px] text-black items-center"
                  key={id}
                >
                  <div className="w-5/12">{orderProducts[0]?.productName}</div>
                  <div className="w-4/12">
                    <KoboConverter amount={totalProductsAmount} />
                  </div>
                  <div className="w-3/12 capitalize">{orderStatus}</div>
                </div>
              )
            )}
      </div>
      {/* <div className="w-5/12">{product}</div>
          <div className="w-4/12">{amount}</div>
          <div className="w-3/12 text-[14px]">
            <span
              className={`${
                status === "In progress"
                  ? "bg-[#F0F6FF] text-[#3A88FC] p-2 rounded-md"
                  : status === "Delivered"
                  ? "bg-[#E4FFEB] text-[#0CA364] p-2 rounded-md"
                  : status === "Cancelled"
                  ? "bg-[#FFF4F3] text-[#F44336] p-2 rounded-md"
                  : "bg-[#FFFFFF] text-[#000000] p-2 rounded-md"
              }`}
            >
              {status}
            </span>
          </div> */}
    </div>
  );
};

export default OrderHistory;

// const orderHistory = [
//   {
//     id: 1,
//     product: "Pineapple - Cotonou",
//     amount: "60,000",
//     status: "In progress",
//   },
//   {
//     id: 2,
//     product: "50kg Bag of Rice",
//     amount: "60,000",
//     status: "Delivered",
//   },
//   {
//     id: 3,
//     product: "Lipton Green Tea X20",
//     amount: "60,000",
//     status: "Cancelled",
//   },
//   {
//     id: 1,
//     product: "Lipton Green Tea X20",
//     amount: "60,000",
//     status: "Delivered",
//   },
//   {
//     id: 1,
//     product: "Irish Potato 5 KG",
//     amount: "60,000",
//     status: "Delivered",
//   },
// ];
